export default {
  dbs_gross_revenue: 'Total Gross Revenue_IEGG',
  dbs_profit: 'Total Profit_IEGG',
  dbs_ytm_actual_short: '25A',
  // dbs_ytm_actual_short_26: '26A',
  dbs_ytm_actual: 'YTM Actual (25A)',
  // dbs_ytm_actual_26: 'YTM Actual (26A)',
  dbs_ytm_actual_dynamic: 'YTM Actual ({yearPrefix}A)',
  dbs_spend_to_date: 'Spend to Date',
  dbs_full_year_forecast: 'Full Year Forecast (25F)',
  // dbs_full_year_forecast_26: 'Full Year Forecast (26F)',
  dbs_full_year_forecast_short: '25F',
  // dbs_full_year_forecast_short_26: '26F',
  dbs_full_year_neutral_forecast: 'Full Year Neutral Forecast  (25F)',
  dbs_full_year_business_forecast: 'Full Year Business Team Forecast  (25F)',
  dbs_full_year_forecast_dynamic: 'Full Year Forecast ({yearPrefix}F)',
  dbs_full_year_neutral_forecast_dynamic: 'Full Year Neutral Forecast ({yearPrefix}F)',
  dbs_full_year_business_forecast_dynamic: 'Full Year Business Team Forecast ({yearPrefix}F)',
  dbs_full_year_neutral_forecast_short: '25F - Neutral',
  dbs_full_year_business_forecast_short: '25F - Business Team',
  dbs_ytm_actual_avg: 'YTM Actual Avg.',
  dbs_full_year_kpi_avg: 'Full Year KPI Avg.',
  dbs_full_year_kpi_short: '25B',
  // dbs_full_year_kpi_short_26: '26B',
  dbs_full_year_kpi: 'Full Year  KPI (25B)',
  dbs_full_year_kpi_dynamic: 'Full Year  KPI ({yearPrefix}B)',
  dbs_full_year_kpi_26: 'Full Year  KPI (26B)',
  dbs_update_time_month: 'Monthly',
  dbs_update_time_year: 'Annually',
  dbs_update_time_quarter: 'Quarterly',
  dbs_update_time_quarter_or_month: 'Quarterly/Monthly',
  dbs_update_time_need: 'As Needed',
  dbs_update_time_irregular: '不定期',
  dbs_update_time_as_need: 'As Needed',
  dbs_ytm_acutal_definition: 'Year-to-date (as of month end) actual',
  dbs_full_year_forecast_definition: 'Full-year forecast',
  dbs_full_year_kpi_definition: 'Full-year L1 KPI',
  dbs_full_year_kpi_definition_l2: 'Full-year L2 KPI',
  dbs_business_full_year_forecast_neutral_definition: 'Full-year forecast from Finance Team, based on inputs from business teams and Forecast Team',
  dbs_business_full_year_forecast_business_definition: 'Full-year forecast from business team',
  dbs_spend_to_date_definition: 'Cummulative actual development spend to date',
  dbs_update_source_finance: 'Finance',
  dbs_update_source_pmi: 'PMI',
  dbs_update_source_databrain: 'Databrain',
  dbs_update_source_gms: 'GMS',
  dbs_mkt_acutal_definition: 'Year-to-date (as of month end) actual approved MKT cost',
  // dbs_mkt_full_year_forecast_definition: 'Total year-to-date (as of month end) marketing spend forecast for all IEGG projects (latest version)',
  // dbs_mkt_full_year_kpi_definition: 'Full-year marketing budget for all IEGG projects (L2 KPI)',
  dbs_mkt_25A_25B: 'Marketing budget utilization progress',
  dbs_mkt_sustainability: 'Actual cost against both the total budget and project timeline',
  // dbs_overview_mkt_total_revenue_ytm_actual_definition: 'Total year-to-date (as of month end) revenue for IEGG\'s overall publishing business',
  // dbs_overview_mkt_total_revenue_full_year_Forecast_definition: 'Full-year revenue forecast for IEGG\'s overall publishing  business (latest version)',
  // dbs_overview_mkt_total_revenue_full_year_kpi_definition: 'Full-year revenue target for IEGG\'s overall publishing operations (L2 KPI)',
  // dbs_overview_mkt_total_profit_ytm_actual_definition: 'Total year-to-date (as of month end) profit for IEGG\'s overall publishing operations (updated quarterly/semi-annually, figures may be zero in some periods)',
  // dbs_overview_mkt_total_profit_full_year_Forecast_definition: 'Full-year profit forecast for IEGG\'s overall publishing operations (latest version; date-independent)',
  // dbs_overview_mkt_total_profit_full_year_kpi_definition: 'Full-year profit target for IEGG\'s overall publishing operations (L2 KPI)',
  dbs_publishing_headcount_actual_definition: 'Headcount allocated for the current month',
  dbs_publishing_headcount_ytm_actual_avg_definition: 'Year-to-date (as of month end) monthly average headcount allocation',
  dbs_publishing_headcount_full_year_kpi_avg_definition: 'Full-year monthly average headcount budget',
  dbs_publishing_headcount_model_suggested_hc_definition: 'Model-suggested optimal headcount',
  dbs_publishing_headcount_suggested_value_definition: 'Customized headcount suggestion',
  dbs_publishing_headcount_publishing_business_definition: 'Total headcount across all IEGG publishing business',
  // dbs_publishing_project_revenue_ytm_actual_definition: 'The project\'s total year-to-date (as of month end) revenue',
  // dbs_publishing_project_revenue_full_year_forcast_definition: 'The project\'s full-year revenue forecast (latest version)',
  // dbs_publishing_project_revenue_full_year_kpi_definition: 'The project\'s full-year revenue target (L2 KPI)',
  // dbs_publishing_project_mkt_ytm_actual_definition: 'The project\'s total year-to-date (as of month end) marketing cost',
  // dbs_publishing_project_mkt_full_year_forcast_definition: 'The project\'s total year-to-date (as of month end) marketing cost forecast (latest version)',
  // dbs_publishing_project_mkt_full_year_kpi_definition: 'The project\'s full-year marketing budget (L2 KPI)',
  dbs_publishing_project_headcount_actual_definition: 'Headcount allocated for the current month',
  dbs_publishing_project_headcount_ytm_actual_avg_definition: 'Year-to-date (as of month end) monthly average headcount allocation',
  dbs_publishing_project_headcount_full_year_kpi_avg_definition: 'Full-year monthly average headcount budget',
  // dbs_publishing_project_tech_ytm_actual_definition: 'The project\'s total year-to-date (as of month end) central service costs',
  // dbs_publishing_project_tech_ytm_actualfull_year_forcast_definition: 'The project\'s total year-to-date (as of month end) central service cost forecast (latest version)',
  // dbs_publishing_project_tech_ytm_actualfull_year_kpi_definition: 'The project\'s full-year central service budget',
  dbs_studio_in_dev_project_budget_to_next_milestone_definition: 'Estimated total budget for the full project lifecycle	',
  dbs_studio_in_dev_project_overall_budget_definition: 'Approved total budget for the full project lifecycle	',
  dbs_studio_in_dev_project_planned_current_milestone_definition: 'Planned number of headcount for the current milestone',
  dbs_studio_in_dev_project_planned_next_milestone_definition: 'Planned number of headcount for the upcoming milestone',
  dbs_studio_in_dev_project_actual_definition: 'Current actual number of headcount assigned to the project',
  dbs_view: 'View',
  dbs_line_chart: 'Line Chart',
  dbs_bar_chart: 'Bar Chart',
  dbs_table: 'Table',
  dbs_download: 'Download',
  dbs_stacked_chart: 'Stacked Chart',
  dbs_charts_legend_actual: 'Actual',
  dbs_charts_legend_forecast: 'Forecast',
  dbs_charts_legend_forecast_total: 'Forecast Total',
  dbs_charts_legend_budget: 'Budget',
  dbs_charts_legend_kpi: 'KPI',
  dbs_charts_legend_actual_total: 'Actual Total',
  dbs_yoy: 'YoY',
  dbs_mom: 'MoM',
  dbs_25A_YoY_percent_definition: '(2025 year-to-date actual / 2024 actual for the same period) -1',
  dbs_YTM_KPI_definition: 'Year-to-date actual / year-to-date L1 KPI',
  dbs_25_KPI_definition: 'Year-to-date actual / full-year L1 KPI',
  dbs_surplus_deficit_definition: '25F minus 25B',
  dbs_model_suggested_hc_definition: 'Optimal headcount suggested by the model',
  dbs_suggested_value_definition: 'The number of headcount suggested by the model	',
};
